// ================================================================================
// script.js
// 案件用のスクリプトファイル
// ================================================================================

// DOM Read for Vanilla
// --------------------------------------------------------------- //

document.addEventListener('DOMContentLoaded', () => {

	// breakpoint
	const breakpoint = window.matchMedia( 'screen and (min-width: 960px)' )

	// scroll volume
	function getScrolled() {
		return ( window.pageYOffset !== undefined ) ? window.pageYOffset: document.documentElement.scrollTop;
	}



	// variable
	// --------------------------------------------------------------- //

	// scroll
	let scrollTop = window.pageYOffset

	// url
	let url = location.href



	// Dropdown for mobile
	// --------------------------------------------------------------- //

	const dropDownButton = document.getElementById('js-mobile-menu');
	const menuOpenBackground = document.body;
	const navCloseButton = document.querySelector('.js-navigation-close button');
	const siteNavigation = document.querySelector('.wp-pattern-site-navigation');

	function isMenuOpen() {
		return menuOpenBackground.classList.contains('is-menu-open');
	}

	function openMenu() {
		dropDownButton.classList.add('is-close');
		menuOpenBackground.classList.add('is-menu-open');
	}

	function closeMenu() {
		dropDownButton.classList.remove('is-close');
		menuOpenBackground.classList.remove('is-menu-open');
	}

	function toggleMenu() {
		if ( isMenuOpen() ) {
			closeMenu();
			return;
		}
		openMenu();
	}

	if ( dropDownButton ) {
		dropDownButton.addEventListener('click', function(e) {
			e.preventDefault();
			toggleMenu();
		});
	}

	if ( navCloseButton ) {
		navCloseButton.addEventListener('click', function(e) {
			e.preventDefault();
			closeMenu();
		});
	}

	// ナビゲーション以外クリックで閉じる
	document.addEventListener('click', function(e) {
		if ( ! isMenuOpen() ) {
			return;
		}
		if ( ! siteNavigation ) {
			return;
		}
		if ( siteNavigation.contains(e.target) ) {
			return;
		}
		if ( dropDownButton && dropDownButton.contains(e.target) ) {
			return;
		}
		closeMenu();
	});

	// Escで閉じる
	document.addEventListener('keydown', function(e) {
		if ( ! isMenuOpen() ) {
			return;
		}
		if ( e.key === 'Escape' || e.key === 'Esc' ) {
			closeMenu();
		}
	});



	// Scroll Spy Navigation
	// --------------------------------------------------------------- //

	{
		const nav = document.querySelector('.js-scrollspy-navigation');
		if (nav) {
			const links = Array.from(nav.querySelectorAll('a[href^="#"]'));
			if (links.length) {
				const map = new Map();
				links.forEach((a) => {
					const id = a.getAttribute('href')?.slice(1);
					if (!id) return;
					map.set(id, a);
				});

				const sections = Array.from(map.keys())
					.map((id) => document.getElementById(id))
					.filter(Boolean);

				if (sections.length) {
					const clearActive = () => {
						links.forEach((a) => a.classList.remove('is-active'));
					};

					const setActive = (id) => {
						clearActive();
						const target = map.get(id);
						if (target) target.classList.add('is-active');
					};

					const getOffset = () => {
						const style = window.getComputedStyle(nav);
						const isSticky = style.position === 'sticky' || style.position === 'fixed';
						return isSticky ? Math.ceil(nav.getBoundingClientRect().height) : 0;
					};

					const update = () => {
						const offset = getOffset();
						const line = offset + 1;

						let currentId = null;

						for (let i = 0; i < sections.length; i++) {
							const rect = sections[i].getBoundingClientRect();
							if (rect.top <= line) currentId = sections[i].id;
						}

						if (!currentId) {
							clearActive();
							return;
						}

						setActive(currentId);
					};

					let ticking = false;
					const onScroll = () => {
						if (ticking) return;
						ticking = true;
						requestAnimationFrame(() => {
							update();
							ticking = false;
						});
					};

					window.addEventListener('scroll', onScroll, { passive: true });
					window.addEventListener('resize', update);
					window.addEventListener('load', update);
					window.addEventListener('pageshow', update);
				}
			}
		}
	}



	// Categories More
	// --------------------------------------------------------------- //

	{
		const wrappers = document.querySelectorAll('.categories-more-wrapper');
		if (wrappers.length) {
			wrappers.forEach((wrapper) => {
				const btnOpen = wrapper.querySelector('.js-categories-more-open .wp-block-button__link');
				const btnClose = wrapper.querySelector('.js-categories-more-close .wp-block-button__link');
				if (!btnOpen || !btnClose) return;

				const open = () => wrapper.classList.add('is-expanded');
				const close = () => wrapper.classList.remove('is-expanded');

				btnOpen.addEventListener('click', (e) => {
					e.preventDefault();
					open();
				});

				btnClose.addEventListener('click', (e) => {
					e.preventDefault();
					close();
				});
			});
		}
	}



	// Front Page Hero
	// --------------------------------------------------------------- //

	window.addEventListener('load', () => {
		const heroCopy = document.querySelector('.js-front-hero-copy');
		if (!heroCopy) return;

		const mainItems = heroCopy.querySelectorAll('.front-hero-copy__main-text');
		const subItem = heroCopy.querySelector('.front-hero-copy__sub');

		mainItems.forEach((item) => {
			item.classList.add('is-show');
		});

		if (subItem) {
			setTimeout(() => {
				subItem.classList.add('is-show');
			}, 420);
		}
	});



	// フォーム系
	// --------------------------------------------------------------- //

	// ajaxzipを使って郵便番号を入れたら自動で住所を入力させる
	const zipField = document.querySelector('input[name="post-code"]');
	const addressField = document.querySelector('input[name="address"]');
	if (!zipField || !addressField) return;

	const prefHidden   = createHiddenField('ajaxzip3_pref');
	const cityHidden   = createHiddenField('ajaxzip3_city');
	const streetHidden = createHiddenField('ajaxzip3_street');

	const form = zipField.closest('form');
	if (form) {
		form.appendChild(prefHidden);
		form.appendChild(cityHidden);
		form.appendChild(streetHidden);
	}

	zipField.addEventListener('input', () => {
		const zipcode = zipField.value.replace(/[^0-9]/g, '');
		if (zipcode.length >= 7) {
			AjaxZip3.zip2addr('post-code', '', 'ajaxzip3_pref', 'ajaxzip3_city', 'ajaxzip3_street');

			setTimeout(() => {
				const pref   = prefHidden.value   || '';
				const city   = cityHidden.value   || '';
				const street = streetHidden.value || '';
				addressField.value = pref + city + street;
			}, 100);
		}
	});

	function createHiddenField(name) {
		const input = document.createElement('input');
		input.type = 'text';
		input.name = name;
		input.style.display = 'none';
		return input;
	}


} );
